<!-- Console V0.1.141; V1.16.32 customer access; 2026-10-09 01:56 CST; parent f4950b06d79d73b88b5515e22ad3015189c67c2b. -->
<!-- Console delegation V1.0; 2026-10-07 09:05:47 CST; parent dcebd36069b2ddb3e45e586f2c90a0214b9a2a4f. -->
<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { httpClient, clearConsoleSessionStorage } from '../api/client';
import { readDelegation } from '../auth/delegationSession';
const session = readDelegation();
const leaving = ref(false);
const failure = ref('');
let timer: ReturnType<typeof setInterval> | undefined;
function leaveLocally() { clearConsoleSessionStorage(); window.location.replace('/delegation-ended'); }
async function leave() {
  leaving.value = true; failure.value = '';
  try { await httpClient.post('/api/v1/auth/delegation/end'); leaveLocally(); }
  catch { failure.value = '退出未确认，请重试。'; }
  finally { leaving.value = false; }
}
onMounted(() => { if (session) timer = setInterval(() => { if (Date.now() >= session.expiresAt) leaveLocally(); }, 1000); });
onBeforeUnmount(() => clearInterval(timer));
</script>
<template>
  <div v-if="session" class="delegation-banner" role="status">
    <span>管理员代理访问：<strong>{{ session.customerName }}</strong> · 操作者 {{ session.operatorName }} · 有效期 {{ session.expiresIn === 18000 ? '5 小时' : '30 分钟' }}</span>
    <el-button size="small" :loading="leaving" @click="leave">退出客户控制台</el-button>
    <span v-if="failure">{{ failure }}</span>
  </div>
</template>
<style scoped>
.delegation-banner { display: flex; flex-wrap: wrap; align-items: center; justify-content: space-between; gap: 12px; padding: 12px 16px; margin-bottom: 16px; border: 1px solid #b8daca; background: #eff8f2; border-radius: 8px; color: #174e36; font-size: 13px; }
</style>
